module.exports = __webpack_public_path__ + "static/media/Bekers.c30fa530.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Bekers.jpg
// module id = 315
// module chunks = 0